import { defineComponent as _defineComponent } from 'vue'
import { ProfileStoreKey } from '@/models/Profile';
import useProfileState from '@/state/profile/profileState';
import ProfileSection from '@/views/profile/components/ProfileSection.vue';
import ProfileBasicEditor from '@/views/profile/components/editors/ProfileBasicEditor.vue';
import ProfileSkillsEditor from '@/views/profile/components/editors/ProfileSkillsEditor.vue';
import ProfileBasicView from '@/views/profile/components/views/ProfileBasicView.vue';
import ProfileInvitedBy from '@/views/profile/components/views/ProfileInvitedBy.vue';
import ProfileSkillsView from '@/views/profile/components/views/ProfileSkillsView.vue';
import { inject } from 'vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileGuest',
  setup(__props) {

const {
  isEditSectionOpen, isSectionFilled,
} = useProfileState(ProfileStoreKey.PROFILE);

const { isMobileWidth } = useResponsiveness();
const breadcrumbs = inject('breadcrumbs', []);

return { __sfc: true,isEditSectionOpen, isSectionFilled, isMobileWidth, breadcrumbs, ProfileSection, ProfileBasicEditor, ProfileSkillsEditor, ProfileBasicView, ProfileInvitedBy, ProfileSkillsView, BCXContentArea, BCXBreadcrumbs }
}

})